<template>

	<!-- Page header -->
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click="getNotifiche()"> Notifiche </a>
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1"><Translate :path="'dizionario.base.ELENCO'"></Translate> Notifiche</span>
				</h4>
				<a href="#page_header" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
			</div>
		</div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a href="#notifiche-a" class="navbar-nav-link navbar-nav-link-icon navbar-sm active rounded" data-bs-toggle="tab" aria-selected="true" role="tab">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="icon-menu7"></i>
								<span class="hidden-xs ms-1"><Translate :path="'dizionario.base.ELENCO'" class="me-1"></Translate>Notifiche</span>
							</div>
						</a>
					</li>
				</ul>

				<div class="navbar-collapse collapse" id="profile_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item dropdown ms-lg-1">
							<div class="btn-group">
								<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
									<i class="ph-gear me-1"></i>
									<span style="font-size:0.8rem;">Azioni Multiple</span>
								</a>
								<div class="dropdown-menu dropdown-menu-end">
									<a href="#" class="dropdown-item" v-on:click.prevent="leggiNotificheSelezionate()">
										<i class="ph-check fa-fw me-2"></i>Segna come lette
									</a>
									<a href="#" class="dropdown-item" v-on:click.prevent="nonlettaNotificheSelezionate()">
										<i class="ph-x fa-fw me-2"></i>Segna come non lette
									</a>
									<div class="dropdown-divider"></div>
									<a href="#" class="dropdown-item" v-on:click.prevent="deleteNotificheSelezionate()">
										<i class="far fa-trash fa-fw me-2 text-danger"></i>Elimina selezionati
									</a>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- /profile navigation -->

	</div>
	<!-- /page header -->

	<!-- Content area -->
    <div class="content content-1 table-cms-wrapper">
		<div class="tab-content flex-1 order-2 order-lg-1">

			<div class="tab-pane fade active show" id="notifiche-a">
				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse" role="button" aria-expanded="false">
								MOSTRA FILTRI
							</a>
						</div>
					</div>
					<div class="collapse" :class="{ show: !$root.isMobile }" id="collapse-all">
						<div class="card-body pb-0">
							<div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#">
									<div class="row">
										<div class="col-6 col-md-1 col-lg-1 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="ID" v-model="search.ID_NOTIFICA.VALUE" />
										</div>
										<div class="col-6 col-md-2 col-lg-2 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Tipologia" v-model="search.TITOLO.VALUE" />
										</div>
										<div class="col-12 col-md-2 col-lg-2 mbx-1" v-if="isGod">
											<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Utente" v-model="search.USERNAME.VALUE" />
										</div>
										<div class="col-6 col-md-2 col-lg-2 mbx-1">
											<Datepicker model-type="dd/MM/yyyy" :formats="{ input: 'dd/MM/yyyy' }" auto-apply :hide-navigation="['time']" placeholder="Dal" v-model="search.ORARIO.VALUE_FROM"></Datepicker>
										</div>
										<div class="col-6 col-md-2 col-lg-2 mbx-1">
											<Datepicker model-type="dd/MM/yyyy" :formats="{ input: 'dd/MM/yyyy' }" auto-apply :hide-navigation="['time']" placeholder="Al" v-model="search.ORARIO.VALUE_TO"></Datepicker>
										</div>
										<div class="col-6 col-md-2 col-lg-2 mbx-1">
											<select class="form-select form-select-sm" v-model="filtroLettura">
												<option value="">Tutte</option>
												<option value="NON_LETTA">Non lette</option>
												<option value="LETTA">Lette</option>
											</select>
										</div>
										
									</div>
								</form>
							</div>
						</div>
					</div>

		        <div class="card-body box-card mt-0 mb-0" id="box-card">
					<div class="div_table_resp tableFixHead" id="tableFixHead">
	               		<table class="table table-bordered table-hover table-striped table-togglable text-nowrap">
		                    <thead class="sticky-top">
								<tr class="bg-secondary text-white">
									<th class="table-head-sm" style="width:2%"><input id="chkAllNotifiche" v-on:click="filters.selectAll('chkAllNotifiche', paginatedList.arr)" type="checkbox" class=""></th>
									<th class="table-head-sm" style="width:5%"># <ISort class="float-end" v-model="ordinamento" :campo="'ID_NOTIFICA'"></ISort></th>
									<th class="table-head-sm" style="width:13%">Data <ISort class="float-end" v-model="ordinamento" :campo="'ORARIO'"></ISort></th>
									<th class="table-head-sm" style="width:12%" v-if="isGod">Utente</th>
									<th class="table-head-sm" style="width:15%">Tipologia</th>
									<th class="table-head-sm">Descrizione</th>
									<th class="table-head-sm text-center" style="width:8%">Stato</th>
									<th class="table-head-sm text-center" style="width:8%">Azioni</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="notifica in paginatedList.arr" v-bind:key="notifica.ID_NOTIFICA">
									<td class="td-class text-center">
										<input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="notifica.SELEZIONATO" class="">
									</td>
									<td class="td-class fs-sm">{{ notifica.ID_NOTIFICA }}</td>
									<td class="td-class fs-sm">{{ filters.formatDateTime(notifica.ORARIO, 'YYYY-MM-DD HH:mm:ss') }}</td>
									<td class="td-class fs-sm" v-if="isGod">{{ notifica.USERNAME }}</td>
									<td class="td-class fs-sm">{{ notifica.TITOLO }}</td>
									<td class="td-class fs-sm">{{ notifica.DESCRIZIONE }}</td>
									<td class="td-class text-center">
										<span v-if="notifica.DATA_LETTURA" class="badge bg-success bg-opacity-20 text-success">Letta</span>
										<span v-else class="badge bg-warning bg-opacity-20 text-warning">Non letta</span>
									</td>
									<td class="td-class text-center">
										<div class="dropdown">
											<a href="#" class="text-body" data-bs-toggle="dropdown" aria-expanded="false"><i class="ph-list"></i></a>
											<div class="dropdown-menu dropdown-menu-end">
												<div class="dropdown-header text-uppercase font-size-xs line-height-xs">Gestione</div>
												<a href="#" class="dropdown-item" v-if="!notifica.DATA_LETTURA" v-on:click.prevent="leggiNotifica(notifica.ID_NOTIFICA)">
													<i class="ph-check fa-fw me-2"></i><span class="text-muted me-1">|</span>Segna come letta
												</a>
												<a href="#" class="dropdown-item" v-if="notifica.DATA_LETTURA" v-on:click.prevent="nonlettaNotifica(notifica.ID_NOTIFICA)">
													<i class="ph-x fa-fw me-2"></i><span class="text-muted me-1">|</span>Segna come non letta
												</a>
												<div class="dropdown-divider"></div>
												<a href="#" class="dropdown-item" v-on:click.prevent="deleteNotifica(notifica.ID_NOTIFICA)">
													<i class="ph-trash fa-fw text-danger me-2"></i><span class="text-muted me-1">|</span>Elimina
												</a>
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

	                <div class="row page-bottom">
						<div class="col-12 col-md-5 d-none d-sm-block" :tabindex="27">
                            <div style="position: relative; top: 10px;">
                                <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 ms-2">Totale: {{ paginatedList.count }}</span>
                            </div>
                        </div>
						<div class="col-9 col-md-6" :tabindex="27">
		                    <div class="float-end pag-mobile">
								<Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
							</div>
						</div>
						<div class="col-3 col-md-1" :tabindex="28">
							<select class="form-select form-select-sm wmin-100 mt-2 float-end" data-placeholder="Limite" :tabindex="20" v-model="search.PAGINATION.PAGE_SIZE" style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
								<option value="5">5</option>
								<option value="10">10</option>
								<option value="25">25</option>
								<option value="50">50</option>
								<option value="75">75</option>
								<option value="100">100</option>
								<option value="250">250</option>
								<option value="500">500</option>
							</select>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
	</div>

</template>



<script>

import Pagine from '@/components/utils/Pagine.vue'
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker'
import ISort from '@/components/utils/ISort.vue'


export default {
    name:"Notifiche",

    emits:[''],

    components:{
        Pagine,
        Datepicker,
		ISort,
    },

    data:function(){
        return {
            filters:global.filters,
            arrayNotifiche:new Array(),
			ordinamento:'',
            search:{
	            PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
	            ID_NOTIFICA:{TYPE:'TEXT',VALUE:''},
                TITOLO:{TYPE:'TEXT',VALUE:''},
                USERNAME:{TYPE:'TEXT',VALUE:''},
                ORARIO:{TYPE:'DATE_RANGE',VALUE_FROM:'',VALUE_TO:''},
	        },
            filtroLettura:'',
        }

    },

    methods:{
        getNotifiche:function(){
            utils.ajax('shared/notifiche/allutente', { FK_ID_UTENTE: this.$root.utente.ID_UTENTE }, (response) => {
                if (response.esito == 0){
                    this.arrayNotifiche = response.data;
                    for (var i = 0 ; i < this.arrayNotifiche.length ; i++){
                        this.arrayNotifiche[i].SELEZIONATO = 0;
                    }
                }
            });
        },

		leggiNotifica:function(idNotifica){
            utils.ajax('shared/notifiche/leggiNotifica', { FK_ID_NOTIFICA: idNotifica, FK_ID_UTENTE: this.$root.utente.ID_UTENTE }, (response) => {
                if (response.esito == 0) this.getNotifiche();
            });
        },

		nonlettaNotifica:function(idNotifica){
            utils.ajax('theb/notifiche/nonlettaNotifica', { FK_ID_NOTIFICA: idNotifica, FK_ID_UTENTE: this.$root.utente.ID_UTENTE }, (response) => {
                if (response.esito == 0) this.getNotifiche();
            });
        },

		deleteNotifica:function(idNotifica){
            utils.alert.confirm('Confermi l\'eliminazione della notifica?', () => {
                utils.ajax('shared/notifica/delete', { ID_NOTIFICA: idNotifica }, (response) => {
                    if (response.esito == 0) this.getNotifiche();
                });
            }, this.$root);
        },

		deleteNotificheSelezionate:function(){
            var sel = this.arrayNotifiche.filter(n => n.SELEZIONATO == 1);
            if (sel.length == 0){
                utils.alert.warning('Nessuna notifica selezionata');
                return;
            }
            utils.alert.confirm('Confermi l\'eliminazione delle ' + sel.length + ' notifiche selezionate?', () => {
                var count = 0;
                for (var i = 0 ; i < sel.length ; i++){
                    utils.ajax('shared/notifica/delete', { ID_NOTIFICA: sel[i].ID_NOTIFICA }, (response) => {
                        count++;
                        if (count == sel.length) {
                            this.getNotifiche();
                            document.getElementById('chkAllNotifiche').checked = false;
                        }
                    });
                }
            }, this.$root);
        },

		leggiNotificheSelezionate:function(){
            var sel = this.arrayNotifiche.filter(n => n.SELEZIONATO == 1);
            if (sel.length == 0){ utils.alert.warning('Nessuna notifica selezionata'); return; }
            utils.alert.confirm('Confermi di segnare come lette le ' + sel.length + ' notifiche selezionate?', () => {
                utils.ajax('theb/notifiche/leggiNotificheSelezionate', { FK_ID_UTENTE: this.$root.utente.ID_UTENTE, IDS: sel.map(n => n.ID_NOTIFICA) }, (response) => {
                    if (response.esito == 0) {
                        this.getNotifiche();
                        document.getElementById('chkAllNotifiche').checked = false;
                    }
                });
            }, this.$root);
        },

		nonlettaNotificheSelezionate:function(){
            var sel = this.arrayNotifiche.filter(n => n.SELEZIONATO == 1);
            if (sel.length == 0){ utils.alert.warning('Nessuna notifica selezionata'); return; }
            utils.alert.confirm('Confermi di segnare come non lette le ' + sel.length + ' notifiche selezionate?', () => {
                utils.ajax('theb/notifiche/nonlettaNotificheSelezionate', { FK_ID_UTENTE: this.$root.utente.ID_UTENTE, IDS: sel.map(n => n.ID_NOTIFICA) }, (response) => {
                    if (response.esito == 0) {
                        this.getNotifiche();
                        document.getElementById('chkAllNotifiche').checked = false;
                    }
                });
            }, this.$root);
        },

    },

    computed: {
        isGod(){
            return this.$root.isGod;
        },
        paginatedList(){
            var arr = this.arrayNotifiche;
            if (this.filtroLettura == 'LETTA')     arr = arr.filter(n => n.DATA_LETTURA);
            if (this.filtroLettura == 'NON_LETTA') arr = arr.filter(n => !n.DATA_LETTURA);
		    var result = utils.inGrid(arr, this.search, this.ordinamento);
		    return result;
        },
    },

    created : function(){
        this.getNotifiche();
    }

}
</script>

<style scoped>
	.grafico { min-height: 451px; }
</style>
